<template>
  <div class="tranferNew">
    <div class="chooseWrap">
      <div class="itemSearch">
        <div class="searchTitle">从</div>
        <el-select
          v-model="fromMarketId"
          popper-class="_whiteSelect"
          clearable
          size="small"
          placeholder="请选择划出市场"
          @change="changeFrom"
        >
          <el-option
            v-for="(item, index) in BaseMarkets"
            :key="index"
            :value="item.marketId"
            :label="item.accountName"
          ></el-option>
        </el-select>
      </div>
      <div class="changeImg">
        <img src="../../../assets//images/change.png" alt="" @click="changeAccount" />
      </div>
      <div class="itemSearch">
        <div class="searchTitle">到</div>
        <el-select
          v-model="toMarketId"
          popper-class="_whiteSelect"
          clearable
          size="small"
          placeholder="请选择划入市场"
          @change="changeTo"
        >
          <el-option
            v-for="(item, index) in BaseMarkets"
            :key="index"
            :value="item.marketId"
            :label="item.accountName"
          ></el-option>
        </el-select>
      </div>
      <div class="itemSearch">
        <div class="searchTitle">划转金额</div>
        <el-input v-model="number" size="small" placeholder="请输入划转金额" />
      </div>
      <div class="itemSearch moneyPwd">
        <div class="searchTitle">资金密码</div>
        <el-input v-model="pwd" :type="passType" size="small" auto-complete="new-password" placeholder="请输入资金密码" >
          <template slot="suffix">
            <img
              class="eyeStyle"
              :src="passwordIcon"
              alt=""
              @click="changeType"
              >
          </template>
        </el-input>
      </div>
      <div class="actionSearch">
        <el-button
          class="searchBtn"
          plain
          size="small"
          :disabled="disable"
          :loading="loading"
          @click="submit"
        >确认</el-button>
        <el-button
          class="restBtn"
          size="small"
          @click="resetData"
        >重填</el-button>
      </div>
    </div>
    <!-- 出入金流水 -->
    <div class="flow">
      <div class="headerWrap">
        <div class="leftText">划转流水查询</div>
      </div>
      <div id="tablePage">
        <el-table
          ref="tableData"
          :data="tableData"
          :height="tableHeight"
          style="width: 100%">
          <template slot="empty">
            <div class="no-datas1">
              <div
                class="no-data-img"
                style="margin: 100px auto 0px; width: 120px; height: 200px;"
              >
                <img
                  src="../../../assets/images/no_data.png"
                  alt=""
                  style="width: 100%;"
                >
                <span>暂无数据</span>
              </div>
            </div>
          </template>
          <el-table-column align="center" prop="flowId" label="记录流水号">
          </el-table-column>
          <el-table-column align="center" prop="accountOut" label="划出市场">
          </el-table-column>
          <el-table-column align="center" prop="accountIn" label="划入市场">
          </el-table-column>
          <el-table-column align="center" prop="amount" label="划转金额">
          </el-table-column>
          <el-table-column align="center" prop="balance" label="余额">
          </el-table-column>
          <el-table-column prop="occurTime" label="划转时间" width="90">
            <template slot-scope="scope">
              {{ scope.row.occurTime | dateFormate }}
            </template>
          </el-table-column>
        </el-table>
        <el-row v-if="pageData.total">
          <el-col :span="24" class="paginateWrap">
            <el-pagination
              class="paginationPage"
              popper-class="_popStyle"
              :current-page="pageData.currentPage"
              :page-sizes="pageData.pageSizes"
              :page-size="pageData.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageData.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
        </el-col>
      </el-row>
      </div>
    </div>
  </div>
</template>
<script>
/*global http protocol protocolTrans util*/
import md5 from 'js-md5'
export default {
  data() {
    return {
      BaseMarkets: window.g.APP_market,
      loading: false,
      disable: false,
      fromMarketId: null,
      toMarketId: null,
      canBeMargin: '--',
      number: '',
      pwd: '',
      tableData: [],
      tableHeight: 0,
      pageData: {
        total: 0,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      },
      passType: 'password',
      passwordIcon: '',
      openImg: require('../../../assets/images/icon/openeye.png'),
      closeImg: require('../../../assets/images/icon/closeeye.png'),
      mineAsset: []
    }
  },
  mounted() {
    this.getmineAsset()
    this.param_queryMyIntegralDetail()
    this.passwordIcon = this.closeImg
  },
  created() {
    window.onresize = () => {
      this.$nextTick(() => {
        this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      this.$refs['tableData'].doLayout()
    })
  },
  methods: {
    changeType() {
      this.passType = this.passType == 'password' ? 'text' : 'password'
      this.passwordIcon =
        this.passType == 'password' ? this.closeImg : this.openImg
    },
    resetData() {
      this.fromMarketId = null
      this.toMarketId = null
      this.number = ''
      this.pwd = ''
      this.canBeMargin = '--'
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.param_queryMyIntegralDetail()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.param_queryMyIntegralDetail()
    },
    // 查询划转记录
    param_queryMyIntegralDetail() {
      protocol.param_queryFundsTransfer.param.sort = [
        {
          direction: 'DESC', // "//DESC或ASC",
          property: 'occurTime' // "//排序属性"
        }
      ]
      protocol.param_queryFundsTransfer.param.page =
        this.pageData.currentPage - 1
      protocol.param_queryFundsTransfer.param.size = this.pageData.pageSize
      http.postFront(protocol.param_queryFundsTransfer).then(response => {
        const { code, message, value } = response.data
        if (Number(code) == 0) {
          const arr = value.content
          this.tableData = arr
          this.pageData.total = value.totalElements
        } else {
          this.$message(message)
        }
      })
    },
    getmineAsset() {
      var firmList = JSON.parse(localStorage.getItem('FirmIdList_w'))
      const firmIds = firmList.map(item => {
        return item.firmId
      })
      protocolTrans.param_mineAsset.param.firmIds = firmIds
      http.postFront(protocolTrans.param_mineAsset).then(response => {
        const { code, message, value } = response.data
        if (Number(code) === 0) {
          this.mineAsset = value
        } else {
          this.mineAsset = []
          this.$message(message)
        }
      })
    },
    //  可划转资金
    searchMoney(value) {
      if (Number(value.marketId !== 0)) {
        if (value) {
          let canBeMargin = util.floatSub(value.balance, value.frozenFunds)
          if (util.floatSub(value.transferClosePl, value.fee) > 0) {
            canBeMargin = util.floatSub(canBeMargin, util.floatSub(value.transferClosePl, value.fee))
          }
          if (value.floatPl < 0) {
            canBeMargin = util.floatAdd(canBeMargin, value.floatPl)
          }
          let canBeMarginL = util.floatAdd(value.lastBalance, value.marketInoutGold)
          if (value.lastHoldPl < 0) {
            canBeMarginL = util.floatAdd(canBeMarginL, value.lastHoldPl)
          }
          if (Number(canBeMargin) <= 0 || Number(canBeMarginL) <= 0) {
            this.canBeMargin = 0
          } else {
            this.canBeMargin = Number(canBeMargin) < Number(canBeMarginL) ? canBeMargin : canBeMarginL
          }
        } else {
          this.canBeMargin = 0
        }
      } else {
        if (value) {
          this.canBeMargin = Number(util.floatSub(value.balance, value.frozenFunds)) <= 0 ? 0 : util.floatSub(value.balance, value.frozenFunds)
        } else {
          this.canBeMargin = 0
        }
      }
    },
    // 资金来源
    changeFrom(selOption) {
      if (!selOption && selOption !== 0) {
        this.canBeMargin = 0
        return
      }
      if (selOption === this.toMarketId) {
        this.$message('划出市场与划入市场不能相同，请重新选择')
        this.fromMarketId = null
        this.canBeMargin = '--'
        return
      }
      try {
        const asset = this.mineAsset.find(item => item.marketId === this.fromMarketId)
        this.searchMoney(asset)
      } catch {
        this.canBeMargin = 0
      }
    },
    changeAccount() {
      const marketId = this.fromMarketId
      this.fromMarketId = this.toMarketId
      this.toMarketId = marketId
      try {
        const asset = this.mineAsset.find(item => item.marketId === this.fromMarketId)
        this.searchMoney(asset)
      } catch {
        this.canBeMargin = 0
      }
    },
    // 资金去向
    changeTo(selOption) {
      if (!selOption && selOption !== 0) {
        return
      }
      if (selOption === this.fromMarketId) {
        this.toMarketId = null
        this.$message('划出市场与划入市场不能相同，请重新选择')
      }
    },
    submit() {
      var test1 = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
      if (!this.number) {
        this.$message('划转金额未填写')
        return
      }
      // 20220224 20220321+|| this.fromMarketId == null
      if (this.fromMarketId === '' || this.fromMarketId == null) {
        this.$message('请选择划出市场')
        return
      }
      // 20220321+|| this.toMarketId == null
      if (this.toMarketId === '' || this.toMarketId == null) {
        this.$message('请选择划入市场')
        return
      }
      if (Number(this.number) <= 0) {
        this.$message('划转资金填写错误')
        return
      }
      if (!test1.test(Number(this.number))) {
        this.$message('划转资金最多为两位小数')
        return
      }
      if (Number(this.number) > Number(this.canBeMargin)) {
        this.$message('划转资金超额')
        return
      }
      if (this.fromMarketId === this.toMarketId) {
        this.$message('划出市场与划入市场不能相同，请重新选择')
        return
      }
      if (!this.pwd) {
        this.$message('请输入资金密码')
        return
      }
      this.loading = true
      this.param_transferFundsOwn()
    },
    // 资金划转(多市场间划转)
    param_transferFundsOwn() {
      this.disable = true
      protocolTrans.param_transferFundsOwn.param.amount = this.number
      protocolTrans.param_transferFundsOwn.param.pwd = md5(
        '47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + this.pwd
      )
      protocolTrans.param_transferFundsOwn.param.fromMarketId = this.fromMarketId
      protocolTrans.param_transferFundsOwn.param.toMarketId = this.toMarketId
      http.postFrontMk0(protocolTrans.param_transferFundsOwn).then(response => {
        const { code, message } = response.data
        // this.$message(message);
        if (Number(code) === 0) {
          this.disable = false
          this.number = ''
          this.pwd = ''
          this.fromMarketId = ''
          this.toMarketId = ''
          this.canBeMargin = '--'
          this.loading = false
          this.getmineAsset()
          this.param_queryMyIntegralDetail()
        } else {
          this.loading = false
          this.disable = false
        }
        this.$message(message)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.tranferNew {
  .changeImg {
    width: 19px;
    height: 14px;
    margin-right: 20px;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .moneyPwd {
    /deep/ .el-input__suffix {
      line-height: 34px;
      right: 14px;
    }
    .eyeStyle {
      width: 18px;
      cursor: pointer;
      vertical-align: middle;
    }
  }
  .headerWrap {
    height: 48px;
    line-height: 48px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    .leftText {
      font-family: Source Han Sans SC;
      font-weight: bold;
      font-size: 20px;
      color: #333333;
    }
  }
}
</style>
